export const GRAPHQL_VARIABLES = {
  record: {
    title: '',
    birth: '',
    firstName: '',
    ownership: '',
    address: {
      address1: '',
      address2: '',
      address3: '',
      state: '',
      city: '',
      zip: '',
      country: '',
      _id: ''
    },
    email: '',
    mobile: '',
    _id: ''
  }
};

export const QUERY = `
 mutation individualUpdateOne ($record: UpdateOneindividualsInput!, $filter: AutoFilledFilterUpdateOneindividualsInput!) {
   individualUpdateOne (record: $record, filter: $filter) {
       recordId
       record {
          title
          birth
          firstName
          lastName
          ownership
          address {
             address1
             address2
             address3
             state
             city
             zip
             country
             _id
          }
          email
          phone
          _id
          documentType
          licenceNumber
          jurisdiction
          country
          additionalDocumentType
          companyId
          roles
          enableDLBackSide
          driverLicence { url contentType }
          passport { url contentType }
          utilityBill { url contentType }
          ssn
       }
   }
 }
 `;
